import { render, staticRenderFns } from "./AppDetails.vue?vue&type=template&id=aeafe6a0&"
import script from "./AppDetails.vue?vue&type=script&lang=js&"
export * from "./AppDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports